<template>
  <div>
    <h1>hello !</h1>
  </div>
</template>

<script>
  export default {
    name: "Home",
    data() {
      return {};
    },
    components: {
      
    }
  };
</script>


<style lang="scss" scoped>
  $h1Color: blue;
  $h1Color_2: rgb(255, 0, 0);

  h1 {
    color: $h1Color;
    font-weight: bolder;
    &:hover {
      color: $h1Color_2;
    }
  }
</style>




// WEBPACK FOOTER //
// src/pages/home.vue